import * as React from 'react';
import { SafeAlertLine } from '@mingcute/react';

import { cn } from '../lib/cn';

export interface ImpersonationBannerProps extends React.HTMLAttributes<HTMLDivElement> {
  userName: string;
  readOnly?: boolean;
  endAction?: React.ReactNode;
}

export const ImpersonationBanner = React.forwardRef<HTMLDivElement, ImpersonationBannerProps>(
  ({ className, userName, readOnly = true, endAction, ...props }, ref) => (
    <div
      ref={ref}
      role="alert"
      className={cn(
        'sticky top-0 z-[var(--z-sticky)] flex w-full items-center gap-3 border-b border-[var(--color-warning-dark)]',
        'bg-[var(--color-warning)] px-4 py-2 text-sm text-[var(--color-neutral-900)]',
        className,
      )}
      {...props}
    >
      <SafeAlertLine size={16} className="shrink-0" aria-hidden />
      <div className="flex-1 min-w-0 truncate">
        <span className="font-semibold">Impersonating {userName}</span>
        {readOnly ? <span className="ml-1 opacity-80">— read only</span> : null}
      </div>
      {endAction ? <div className="shrink-0">{endAction}</div> : null}
    </div>
  ),
);
ImpersonationBanner.displayName = 'ImpersonationBanner';
